import { SuperTokensConfig } from "@/configs/supertokens/config";
import SuperTokensReact from "supertokens-auth-react";

let superTokensInitialized = false;

export function ensureSuperTokensInitialized() {
  if (typeof window === "undefined" || superTokensInitialized) {
    return;
  }

  SuperTokensReact.init(SuperTokensConfig());
  superTokensInitialized = true;
}

export function isSuperTokensInitialized() {
  return superTokensInitialized;
}
